/* The sticky control submits the original Dawn form: one variant, quantity and error path. */
if (!customElements.get('teema-sticky-purchase')) {
  customElements.define('teema-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      this.product = this.closest('product-info');
      this.source = this.product?.querySelector('product-form .product-form__submit');
      this.target = this.querySelector('[data-sticky-submit]');
      if (!this.source || !this.target) return;
      this.sync = () => {
        const busy = this.source.getAttribute('aria-disabled') === 'true';
        this.target.disabled = this.source.disabled || busy;
        this.target.setAttribute('aria-busy', String(busy));
        this.target.querySelector('span').textContent = this.source.querySelector('span').textContent;
      };
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.source, {childList: true, subtree: true, attributes: true});
      // A fast scroll can jump from below to above the viewport without an
      // intersection change. Check position once per frame, including such jumps.
      this.updateVisibility = () => {
        if (this.visibilityFrame) return;
        this.visibilityFrame = requestAnimationFrame(() => {
          this.visibilityFrame = null;
          this.hidden = this.source.getBoundingClientRect().bottom > 0;
        });
      };
      window.addEventListener('scroll', this.updateVisibility, {passive: true});
      window.addEventListener('resize', this.updateVisibility);
      this.updateVisibility();
      this.error = () => {
        const message = this.product.querySelector('.product-form__error-message-wrapper:not([hidden])');
        if (message) message.scrollIntoView({behavior: 'smooth', block: 'center'});
      };
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartError, () => queueMicrotask(this.error));
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('scroll', this.updateVisibility);
      window.removeEventListener('resize', this.updateVisibility);
      cancelAnimationFrame(this.visibilityFrame);
      this.unsubscribe?.();
    }
  });
}
